if (!customElements.get("swiper-slider")) {
  customElements.define(
    "swiper-slider",
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();

        this.swiperEl = this.querySelector(`#${this.id} > .swiper`);
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        this.setupSwiperParams();
        this.swiperInstance = new Swiper(this.swiperEl, this.swiperParams);
      }

      setupSwiperParams() {
        this.swiperParams = {
          allowTouchMove: true,
          speed: this.getAttribute("animation-speed")
            ? parseInt(this.getAttribute("animation-speed"))
            : 1000,
          observer: true,
          resizeObserver: true,
          // Mobile defaults
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          ...(this.getAttribute("enable-autoplay") === "true" && {
            autoplay: {
              delay: this.getAttribute("autoplay-delay")
                ? parseInt(this.getAttribute("autoplay-delay"))
                : 5000,
              disableOnInteraction:
                this.getAttribute("disable-on-interaction") === "true"
                  ? true
                  : false,
            },
          }),
          ...(this.getAttribute("show-navigation-mobile") === "true" && {
            pagination: {
              el: `#${this.id} > .swiper > .slider-navigation-container > .swiper-pagination`,
              clickable: true,
            },
          }),

          // Desktop breakpoint
          breakpoints: {
            769: {
              observer: true,
              speed: this.getAttribute("animation-speed")
                ? parseInt(this.getAttribute("animation-speed"))
                : 1000,
              resizeObserver: true,
              allowTouchMove: true,
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              ...(this.getAttribute("show-navigation") === "true" && {
                pagination: {
                  el: `#${this.id} > .swiper > .slider-navigation-container > .swiper-pagination`,
                  clickable: true,
                },
              }),
            },
          },
          on: {
            init() {
              // hide navigation if there is only one slide or 0
              const numberOfSlides = this.slides.length;
              if (numberOfSlides <= 1) {
                if (this.navigation.nextEl && this.navigation.prevEl) {
                  this.navigation.nextEl.style.display = "none";
                  this.navigation.prevEl.style.display = "none";
                }
              } else {
                if (this.navigation.nextEl && this.navigation.prevEl) {
                  this.navigation.nextEl.style.display = "";
                  this.navigation.prevEl.style.display = "";
                }
              }
            },
            update() {
              // hide navigation if there is only one slide or 0
              const numberOfSlides = this.slides?.length;
              if (numberOfSlides <= 1) {
                if (this.navigation?.nextEl && this.navigation?.prevEl) {
                  this.navigation.nextEl.style.display = "none";
                  this.navigation.prevEl.style.display = "none";
                }
              } else {
                if (this.navigation?.nextEl && this.navigation?.prevEl) {
                  this.navigation.nextEl.style.display = "";
                  this.navigation.prevEl.style.display = "";
                }
              }
            },
          },
        };
      }
    },
  );
}
